import React, { useEffect, useContext } from 'react'
import { parse } from "date-fns";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import useNotification from "../../../hooks/newUXNotification";
import { DialogContext } from "../../../hooks/dialog/context";
import ScheduleModal from './ScheduleModal';
import CredentialsHeader from '../Components/Header'
import SmallInfo from '../../../newUXAssets/icons/SmallInfo'
import SmallFile from '../../../newUXAssets/icons/SmallFile'
import SmallCalendar from '../../../newUXAssets/icons/SmallCalendar'
import SmallClock from '../../../newUXAssets/icons/SmallClock'
import UserCircle from '../../../newUXAssets/icons/UserCircle'
import Pencil from '../../../newUXAssets/icons/Pencil'
import Trash from '../../../newUXAssets/icons/Trash'
import OutlinedPhone from '../../../newUXAssets/icons/OutlinedPhone'
import OutlinePlace from '../../../newUXAssets/icons/OutlinePlace';
import { 
  Container,
  Title,
  ScheduleCard,
  ScheduleCardHeader,
  HeaderTitle,
  Label,
  Button,
  SmallButton,
  LabelButton,
  AlertText,
  ScheduleCardActions,
} from './styles'
import {
  getCredentialSchedule,
  deleteCredentialSchedule,
} from '../../../redux/modules/credentials/actions';
import ConfirmationModal from "../../../newUXComponents/Modal/ConfirmationModal";

const Schedule = () =>{
  const { event, contract } = useSelector((state) => state.initialSettings);
  const { credentialScheduleList } = useSelector((state) => state.credentials);

  const intl = useIntl()
  const dispatch = useDispatch()
  const notification = useNotification()
  const { createDialog } = useContext(DialogContext);

  const callbackError = (message) =>
    notification.displayError(
      intl.formatMessage({ id: "api.error." + message }),
      'credential-schedule-error-message'
    )

  const callbackSuccess = () => {
    notification.displaySuccess(
      intl.formatMessage({
        id: "success.schedule_withdrawal_delete",
      }),
      "remove-credential-schedule-success"
    );
    dispatch(getCredentialSchedule( event.value, contract.value, callbackError ));
  };
  
  useEffect(()=> {
    if(!event || event.length === 0 || JSON.stringify(event) === '{}') {
      notification.displayInfo(
        intl.formatMessage({ id: "error.contract_not_selected" }),
        'event-not-selected-message'
      )
      return
    }
    else notification.close('event-not-selected-message')
    dispatch(getCredentialSchedule( event.value, contract.value, callbackError ))
  },[contract.value, event.value])


  const onClickNew = () => {
    createDialog({
      id: `new-credential-schedule-modal`,
      Component: ScheduleModal,
      props: {
        event,
        contract
      }
    });
  }

  const onClickEdit = (credentialSchedule) => {
    createDialog({
      id: `edit-credential-schedule-modal`,
      Component: ScheduleModal,
      props: {
        credentialSchedule,
        event,
        contract,
        isEdit: true
      }
    });
  }

  const onClickDelete = (id) => {
    createDialog({
      id: "delete-credential-schedule-modal",
      Component: ConfirmationModal,
      props: {
        title: intl.formatMessage({ id: "delete_scheduling" }),
        message: intl.formatMessage({ id: "delete_credential_scheduling" }),
        confirmation: () => {
          dispatch(
            deleteCredentialSchedule(id, callbackSuccess, callbackError)
          );
        },
      },
    });
  }
  
  return(
    <Container>
      <Title>{intl.formatMessage({ id: "credentials" })}</Title>
      <CredentialsHeader isScheduleSelected />
      {event.value && contract.value &&
        <Button
          onClick={onClickNew}>
          <LabelButton>
            + {intl.formatMessage({id: "new_scheduling"})}
          </LabelButton>
        </Button>
      }
      {!credentialScheduleList || credentialScheduleList.length === 0 ? (
        <ScheduleCard>
          <ScheduleCardHeader>
            <HeaderTitle><SmallInfo/> <h3>{intl.formatMessage({id: "scheduling"})}</h3></HeaderTitle>
          </ScheduleCardHeader>
          <AlertText>{intl.formatMessage({id: "no_schedule_to_exhibit"})}</AlertText>
        </ScheduleCard>
      ) : (
        credentialScheduleList.map((credentialSchedule, index) => {
          return (
            <ScheduleCard>
              <ScheduleCardHeader>
                <HeaderTitle><SmallInfo/> <h3>{intl.formatMessage({id: "scheduling"})}</h3></HeaderTitle>
                <ScheduleCardActions>
                  <SmallButton onClick={() => onClickEdit(credentialSchedule)}>
                    <Pencil /><LabelButton>{intl.formatMessage({id: "edit"})}</LabelButton>
                  </SmallButton>
                  <SmallButton color="#002244" onClick={() => onClickDelete(credentialSchedule.credentialScheduleId)}>
                    <Trash /><LabelButton>{intl.formatMessage({id: "delete"})}</LabelButton>
                  </SmallButton>
                </ScheduleCardActions>
              </ScheduleCardHeader>
              <Label><SmallFile/><p className='event'>{credentialSchedule.eventEditionName}</p></Label>
              <Label><OutlinePlace/><p>{intl.formatMessage({id: "withdrawal_place"})}: {credentialSchedule.withdrawalPlace.label}</p></Label>
              <Label><SmallCalendar/><p>{intl.formatMessage({id: "withdrawal_date"})} {intl.formatDate(parse(credentialSchedule.dateSchedule, "yyyy-MM-dd", new Date()))}</p></Label>
              <Label><SmallClock/><p>{intl.formatMessage({id: "schedule_time"})}: {credentialSchedule.timeSchedule}</p></Label>
              <Label><UserCircle size='16'/><p>{intl.formatMessage({id: "name_of_who_withdraws"})}: {credentialSchedule.nameOfWhoWithdraws}</p></Label>
              <Label><OutlinedPhone /><p>{intl.formatMessage({id: "telephone"})}: {credentialSchedule.contact}</p></Label>
            </ScheduleCard>
          )
        })
      )}
    </Container>
  )
}

export default Schedule